'use strict';

/**
 * View for rendering a single storage
 *
 * @category   View
 * @module     collection.location
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/collection/modules/location/templates/partials/storages-item.hbs');

require('jquery-humans-dnd');

var StoragesItemView = ItemView.extend({
    wrapItem: false,

    viewData: {
        displayImage: true,
    },

    template: template,

    ui: {
        'toggleEditMode': '[data-action="toggle-mode"]',
        'formAddSet': '[data-role="form-add-set"]',
        'name': 'input[name="name"]',
    },

    events: {
        'click @ui.toggleEditMode': 'toggleEditMode',
        'submit @ui.formAddSet': 'createSet',
        'reset @ui.formAddSet': 'cancelCreation',
        'keyup @ui.name': 'checkName',
        'keydown @ui.name': 'checkName',
        'change @ui.name': 'checkName',
    },

    modelEvents: {
        'change': 'render',
    },

    initialize: function(options) {
        // Call parent
        ItemView.prototype.initialize.apply(this, arguments);

        // Apply options
        if (typeof options === 'object') {
            if (options.hasOwnProperty('displayImage')) {
                this.viewData.displayImage = options.displayImage;
            }
        }
    },

    /**
     * Toggles the edit mode of the box
     * @param {object} event The event that has triggered the function
     * @return {void}
     */
    toggleEditMode: function(event) {
        var mode  = this.$el.attr('data-mode');
        var empty = this.$el.attr('data-empty');

        if (empty === true || empty === 'true') {
            if (mode === 'view') {
                this.$el.addClass('box-stacked').removeClass('box-empty');
                this.$el.attr('data-mode', 'edit');
                this.$('input[type="submit"]').prop('disabled', true);
                this.$('input[name="name"]').focus();
            } else {
                this.$el.removeClass('box-stacked').addClass('box-empty');
                this.$el.attr('data-mode', 'view');
            }
        }
    },

    /**
     * Checks the name to enable/disable submit button
     * @param {object} event The event that has triggered the function
     */
    checkName: function(event) {
        this.$('input[type="submit"]').prop('disabled', $(event.currentTarget).val().length <= 0);
    },

    /**
     * Creates a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    createSet: function(event) {
        event.preventDefault();
        var $curTarget = $(event.currentTarget);
        var name = $curTarget.find('[name="name"]').val();

        if (typeof this.model.collection === 'object') {
            this.model.collection.create({
                headline: name,
                empty: false,
            }, {at: 0});
        }

        // Disable edit mode
        $curTarget.find('[name="name"]').val('');
        this.toggleEditMode(event);
    },

    /**
     * Cancles the creation of a new set
     * @param event The event that has triggered the function
     * @return {void}
     */
    cancelCreation: function(event) {
        event.preventDefault();
        var $curTarget = $(event.currentTarget);
        $curTarget.find('[name="name"]').val('');

        // Toggle mode
        this.toggleEditMode(event);
    },

    onRender: function() {
        ItemView.prototype.onRender.apply(this, arguments);

        this.$el.humansDrop({
            overClass: 'drop-target-over',
            onDrop: function(event, humansDrop, humansDrag, element) {
                var catalog = this.getOption('catalog');
                var objectId    = humansDrag.getTargetElement().data('id');
                var objectModel = catalog.objects.findWhere({id: objectId});

                var storageModel = this.model;

                App.radio('collection').execute(
                    'change:storage',
                    objectModel,
                    storageModel
                );
            }.bind(this),
        });
    },

    onBeforeDestroy: function() {
        this.$el.humansDrop('destroy');
    },
});

module.exports = StoragesItemView;